module.exports = __webpack_public_path__ + "media/images/bg_mypage_top-ff902d4c624f0463b5b289a29705a37b.jpg";